import React from "react";
import "./style.scss";
const ListCarousel = props => {
  return <div className="c-list-carousel"></div>;
};
export default ListCarousel;
